import { Box, Grid2 as Grid } from "@mui/material";

import AdminSupportCategories from "./AdminSupportCategories";
import AdminSupportEntries from "./AdminSupportEntries";
import AdminSupportPdf from "./AdminSupportPdf";
import AdminSupportSearchTerms from "./AdminSupportSearchTerms";

const AdminSupport = () => {
	return (
		<Grid container spacing={3}>
			<Grid size={6}>
				<Box mb={2}>
					<AdminSupportCategories />
				</Box>

				<AdminSupportEntries />
			</Grid>

			<Grid size={6}>
				<Box mb={2}>
					<AdminSupportPdf />
				</Box>

				<AdminSupportSearchTerms />
			</Grid>
		</Grid>
	);
};

export default AdminSupport;
